import { useState, useEffect } from "react";

import userImage from "./assets/default.jpg";

export default function Chat({ id }) {

  const [messages, setMessages] = useState([
    {
      role: "assistant",
      name: "Anymon",
      content:
        "こんにちは"
    }
  ]);

  const [set_character, setCharacter] = useState(null);

  

  useEffect(() => {

    fetch(`/api/chat/${id}/`)

      .then(res => res.json())

      .then(data => {

        setCharacter(data.character);

      });

  }, [id]);

  // useEffect(() => {
  //   fetch(`/api/chat/${id}/`)
  //     .then(res => res.json())
  //     .then(data => {
  //       setCharacter(data.character);
  //       // user_nameが存在すればtrueにする
  //       if (data.character && data.character.user_name) {
  //         setIsLoggedIn(true);
  //       }
  //     });
  // }, [id]);

  // const path = window.location.pathname;
  // const id = path.split("/").filter(Boolean).pop();

  const isLoggedIn = set_character?.is_authenticated;

  const [messageCount, setMessageCount] = useState(0);
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const handleNewMessage = () => {
    const newCount = messageCount + 1;
    setMessageCount(newCount);

    const bannerShown = localStorage.getItem("bannerShown");
    const modalShown = localStorage.getItem("modalShown");

    if (!isLoggedIn && newCount >= 5 && !bannerShown) {
      setShowBanner(true);
      localStorage.setItem("bannerShown", "true");
    }

    if (!isLoggedIn && newCount >= 10 && !modalShown) {
      setShowModal(true);
      localStorage.setItem("modalShown", "true");
    }
  };

  useEffect(() => {
    let timer;

    if (!isLoggedIn && messageCount >= 10 && !showModal) {
      timer = setTimeout(() => {
        const closedTime = Number(localStorage.getItem("modalClosedTime"));

        if (!closedTime || Date.now() - closedTime > 60000) {
          setShowModal(true);
        }
      }, 5000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [messageCount, showModal]);

  const handleCloseModal = () => {
    setShowModal(false);
    localStorage.setItem("modalClosedTime", Date.now());
  };


  let chatId = id;

  if (!chatId) {
    const path = window.location.pathname;
    chatId = path.split("/").filter(Boolean).pop();
  }

  console.log(chatId);



  const [input, setInput] = useState("");

  const sendMessage = async () => {
    if (!input.trim()) return;

    

    const newMessages = [
      ...messages,
      { role: "user", name: "user", content: input }
    ].slice(-10);

    setMessages(newMessages);
    setInput("");

    try {
      const res = await fetch(`/api/chat/${id}/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          messages: newMessages
        })
      });

      const data = await res.json();
      console.log(data);

      setMessages(prev => [
        ...prev,
        { role: "assistant", content: data.response }
      ]);

      // 👇ここでカウント
      handleNewMessage();


    } catch (error) {
      console.error("エラー:", error);
    }
  };
 


  const images = {};

    for (let i = 1; i <= 30; i++) {
    images[i] = require(`./assets/image${i}.jpg`);
    }

  const CHARACTERS = {
    1: {
        name: "ユナ",
        image: images[1],
        firstMessage: "来てくれてありがとう。今日はどんな気分？"
        },
    2: {
        name: "レオ",
        image: images[2],
        firstMessage: "……別に待ってたわけじゃない"
        },
    3: {
        name: "リーナ",
        image: images[3],
        firstMessage: "ここではゆっくりしていってね"
        },
    4: {
        name: "ユウ",
        image: images[4],
        firstMessage: "ここでは安心していいよ。何でも聞くから"
      },
    5: {
        name: "アオ",
        image: images[5],
        firstMessage: "え、なに〜？話そ〜！"
        },
    6: {
        name: "ミオン",
        image: images[6],
        firstMessage: "えへへ〜来てくれたの？うれしい！"
        },
    7: {
        name: "ドレイク",
        image: images[7],
        firstMessage: "よく来てくれましたね。何かありましたか？"
        },
    8: {
        name: "サツキ",
        image: images[8],
        firstMessage: "こんにちは、来てくれて嬉しいな"
        },
    9: {
        name: "バロン",
        image: images[9],
        firstMessage: "無理すんなって。なんかあった？俺がいるだろ？"
        },
    10: {
        name: "リーン",
        image: images[10],
        firstMessage: "今日もお疲れさま、えらいね。どうしたの？"
        },
    11: {
        name: "シノメ",
        image: images[11],
        firstMessage: "来たのね。…まあ、いいけど"
        },
    12: {
        name: "バスタード",
        image: images[12],
        firstMessage: "最近は、どうだ？"
        },
    13: {
        name: "クウ",
        image: images[13],
        firstMessage: "えへへ〜来てくれたの？うれしい！"
        },
    14: {
        name: "セイレーン",
        image: images[14],
        firstMessage: "別に興味ないけど…話すなら聞くわ"
        },
    15: {
        name: "セイロン",
        image: images[15],
        firstMessage: "来たか。少しは骨のある話を期待してる"
        },
    16: {
        name: "エリザ",
        image: images[16],
        firstMessage: "来たのね。…まあ、いいけど"
        },
    17: {
        name: "ジーク",
        image: images[17],
        firstMessage: "……何の用だ。話だけは聞いてやる"
        },
    18: {
        name: "シュウ",
        image: images[18],
        firstMessage: "会えてうれしいな〜！"
        },
    19: {
        name: "レイ",
        image: images[19],
        firstMessage: "……何の用"
        },
    20: {
        name: "リファ",
        image: images[20],
        firstMessage: "いっぱいおしゃべりしよっ？"
        },
    21: {
        name: "キズナ",
        image: images[21],
        firstMessage: "ここでは安心していいよ。何でも聞くから"
        },
    22: {
        name: "ファオ",
        image: images[22],
        firstMessage: "……何の用じゃ"
        },
    23: {
        name: "アスカ",
        image: images[23],
        firstMessage: "よっ、ちゃんと来たな。いい子いい子"
        },
    24: {
        name: "ホロ",
        image: images[24],
        firstMessage: "あなたの話、ちゃんと聞きたいな"
        },
    25: {
        name: "ネロ",
        image: images[25],
        firstMessage: "無理してない？ゆっくり話していいからね"
        },
    26: {
        name: "ミスター・シュタイン",
        image: images[26],
        firstMessage: "ちょっと疲れてる顔してるね、大丈夫？"
        },
    27: {
        name: "フロウ",
        image: images[27],
        firstMessage: "無駄話は嫌いだけど、君ならいいよ"
        },
    28: {
        name: "メイ",
        image: images[28],
        firstMessage: "おかえり〜！待ってたよ！"
        },
    29: {
        name: "ラオ",
        image:images[29],
        firstMessage: "ほら、座れよ。話聞いてやる"
        },
    30: {
        name: "ラム",
        image: images[30],
        firstMessage: "今日も一緒にいよ？だめ〜？"
        },
  };



  const character = CHARACTERS[id];

  useEffect(() => {
    const saved = localStorage.getItem(`chat_${id}`);
  
    if (saved) {
      setMessages(JSON.parse(saved));
    } else {
      setMessages([
        {
          role: "assistant",
          content: character?.firstMessage || "こんにちは"
        }
      ]);
    }
  }, [id]);





  
  return (
    <div style={styles.container}>

      {/* メッセージ一覧 */}
      <div style={styles.chatArea}>
        {messages.slice(0).map((msg, i) => {

          let name = "";
          let image = "";

          if (msg.role === "user") {
            name = set_character?.user_name;
            image = set_character?.userImage;
          } else if (msg.role === "assistant") {
            name = set_character?.name;
            image = set_character?.image;
          }

          return (
            <div key={i} style={styles.message}>
              <div>
                <img src={image} style={styles.image_anymon} />
              </div>
              <div style={styles.message_content}>
                <strong>{name}：</strong>
                {msg.content}
              </div>
            </div>
          );
        })}
      </div>


      {showBanner && !showModal && (
        <div style={styles.banner}>
          <span style={styles.bannerMessage}>
            登録すると、より高度な機能や快適なチャット体験をご利用いただけます。
          </span>

          <div style={styles.bannerBtns}>
            <button
              style={styles.linkButton}
              onClick={() => setShowBanner(false)}
            >
              あとで
            </button>

            <button
              style={styles.primaryButton}
              onClick={() => window.location.href = "/accounts/signup/"}
            >
              無料登録
            </button>
          </div>
        </div>
      )}

      {showModal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2>無料登録で、よりスムーズで便利なチャット体験を。</h2>

            <p>
              無料登録すると、会話の保存や便利な機能が使えるようになります。
            </p>

            <div style={{ marginTop: "20px" }}>
              <button
                style={styles.primaryButton}
                onClick={() => window.location.href = "/accounts/signup/"}
              >
                無料で続ける
              </button>

              <button
                style={styles.secondaryButton}
                onClick={() => {
                  setShowModal(false);
                  localStorage.setItem("modalClosedTime", Date.now());
                }}
              >
                あとで
              </button>
            </div>
          </div>
        </div>
      )}

      

      {/* 上部：キャラ */}
      {/* <div style={styles.header}>
        <img src={character?.image} style={styles.avatar} />

        <div style={styles.bubble}>
          <strong>{character?.name}：</strong>
          {messages[0].content}
        </div>
      </div> */}

      <hr />

      {/* ユーザー */}
      <div style={styles.userSection}>
        <img
          src={set_character?.userImage}
          alt="user"
          style={styles.userIcon}
        />
        <span>{set_character?.user_name}</span>
      </div>

      {/* 入力欄 */}
      <textarea
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="メッセージをここに入力してください。"
        style={styles.textarea}
      />

      <div style={styles.buttonArea}>
        <button onClick={sendMessage} style={styles.sendBtn}>
          送信
        </button>

        
      </div>

      
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "1000px",
    margin: "10px auto 40px",
    fontFamily: "sans-serif",
    padding: "20px",
    borderRadius: "10px",
  },

  message_content: {
     whiteSpace: 'pre-line',
     margin:"5px",
     marginTop:"15px",
     marginBottom:"20px"
  },


  header: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom:"50px"
  },

  image_anymon: {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    objectFit: "cover"
  },

  image: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    objectFit: "cover"
  },

  bubble: {
    background: "#ddd",
    padding: "15px",
    borderRadius: "10px",
    flex: 1
  },

  userSection: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "20px"
  },

  userIcon: {
    width: "50px",
    height: "50px",
    borderRadius: "50%"
  },

  textarea: {
    width: "98%",
    height: "120px",
    marginTop: "10px",
    marginRight: "10px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #ccc"
  },

  buttonArea: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "10px"
  },

  sendBtn: {
    background: "#f1c40f",
    border: "none",
    padding: "10px 20px",
    borderRadius: "6px",
    cursor: "pointer"
  },

  diaryBtn: {
    background: "#e0a96d",
    border: "none",
    padding: "10px 20px",
    borderRadius: "6px",
    cursor: "pointer"
  },

  chatArea: {
    marginTop: "20px",
    marginBottom:"50px",
  },

  message: {
    background: "#fff",
    padding: "10px",
    paddingTop:"20px",
    borderRadius: "8px",
    marginBottom: "10px",
    display: "flex",
    gap: "20px",
    marginBottom:"50px"
  },

  banner: {
    position: "fixed",
    bottom: "200px",
    left: "50%",            // 画面の真ん中に配置
    transform: "translateX(-50%)", // 自分の幅の半分だけ左に戻す（これで完全に中央！）
    width: "90%",           // 基本は画面幅の90%
    maxWidth: "500px",      // でも500px以上には大きくならない
    color: "#fff",
    background: "rgba(30,30,30,0.9)",
    backdropFilter: "blur(4px)",
    borderRadius: "10px",
    padding: "12px 16px",
    zIndex: 1000,
},

  bannerBtns: {
    marginTop:"10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  },

  modal: {
    background: "#fff",
    padding: "24px",
    borderRadius: "12px",
    width: "320px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },

  primaryButton: {
    background: "#4CAF50",
    color: "#fff",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    marginRight: "8px",
  },

  secondaryButton: {
    background: "#eee",
    border: "none",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  linkButton: {
    background: "transparent",
    color: "#aaa",
    border: "none",
    marginRight: "8px",
    cursor: "pointer",
  },
};